(function(){
  if (window.__kbfFsInit) { return; }
  window.__kbfFsInit = true;

  // 2026-07-22 Turkiye shipping fix: threshold used to be a flat 4900 (i.e.
  // $49.00 in cents) for every visitor. For Turkey-market shoppers (currency
  // TRY) the cart total from /cart.js is denominated in TRY kurus, so this
  // hardcoded number made the bar falsely claim "free shipping unlocked" at
  // ~49 TL instead of the real 1.499 TL threshold on the Turkey shipping
  // zone. window.Shopify.currency.active reflects the shopper's actual
  // active currency and is always present on Shopify storefronts.
  var kbfFsIsTry = !!(window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'TRY');
  var kbfFsThreshold = kbfFsIsTry ? 149900 : 4900;
  var kbfFsLastTotal = null;

  function kbfFsStrings(){
    return window.kbfFsI18n || {
      awayHtml: "You're <b>__AMOUNT__</b> away from <b>FREE Shipping!</b>",
      unlockedHtml: "You've unlocked <b>FREE Shipping!</b>"
    };
  }

  function kbfFsFormatMoney(cents){
    // theme.money_format is the shop's DEFAULT currency template (contains a
    // literal "$"), so running a TRY amount through it prints the wrong
    // symbol. Build the TRY string manually instead.
    if (kbfFsIsTry) {
      return '₺' + Math.round(cents / 100);
    }
    if (window.theme && window.theme.money_format && window.Currency && window.Currency.formatMoney) {
      try { return Currency.formatMoney(cents, theme.money_format); } catch(e){}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function kbfFsRenderFromTotal(totalCents){
    var remaining = kbfFsThreshold - totalCents;
    var percent = Math.min(100, Math.max(0, (totalCents / kbfFsThreshold) * 100));
    var money = kbfFsFormatMoney(Math.max(0, remaining));
    var strings = kbfFsStrings();
    document.querySelectorAll('.kbf-fs-bar').forEach(function(bar){
      var fill = bar.querySelector('.kbf-fs-fill');
      if (fill) fill.style.width = percent + '%';
      var msg = bar.querySelector('.kbf-fs-msg');
      var cta = bar.querySelector('.kbf-fs-cta');
      if (remaining <= 0) {
        bar.classList.add('kbf-fs-done');
        if (msg) {
          msg.classList.add('kbf-fs-msg-done');
          msg.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"></path></svg> ' + strings.unlockedHtml;
        }
        if (cta) cta.style.display = 'none';
      } else {
        bar.classList.remove('kbf-fs-done');
        if (msg) {
          msg.classList.remove('kbf-fs-msg-done');
          var awayHtml = strings.awayHtml.replace('__AMOUNT__', money);
          msg.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h13v13H3z"></path><path d="M16 8h4l1 5v3h-5" ></path><circle cx="7.5" cy="18.5" r="1.5"></circle><circle cx="17.5" cy="18.5" r="1.5"></circle></svg> ' + awayHtml;
        }
        if (cta) cta.style.display = '';
      }
    });
  }

  function kbfFsCheckAndRender(force){
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (!cart || typeof cart.total_price === 'undefined') return;
        if (force || cart.total_price !== kbfFsLastTotal) {
          kbfFsLastTotal = cart.total_price;
          kbfFsRenderFromTotal(cart.total_price);
        }
      })
      .catch(function(){});
  }

  var kbfFsRefetchTimer = null;
  function kbfFsRefetch(){
    clearTimeout(kbfFsRefetchTimer);
    kbfFsRefetchTimer = setTimeout(function(){ kbfFsCheckAndRender(true); }, 200);
  }

  function kbfFsInitHooks(){
    if (window.jQuery) {
      jQuery(document).on('cart.requestComplete', function(event, cart){
        if (cart && typeof cart.total_price !== 'undefined') { kbfFsLastTotal = cart.total_price; kbfFsRenderFromTotal(cart.total_price); }
      });
    }
    if (window.fetch) {
      var kbfOrigFetch = window.fetch;
      window.fetch = function(input, init){
        var p = kbfOrigFetch.apply(this, arguments);
        try {
          var urlStr = (typeof input === 'string') ? input : (input && input.url) || '';
          if (/\/cart\/(add|change|update|clear)(\.js)?/.test(urlStr)) { p.then(function(){ kbfFsRefetch(); }).catch(function(){}); }
        } catch(e){}
        return p;
      };
    }
    if (window.XMLHttpRequest) {
      var kbfOrigOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function(method, url){
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
          this.addEventListener('loadend', function(){ kbfFsRefetch(); });
        }
        return kbfOrigOpen.apply(this, arguments);
      };
    }
    document.addEventListener('submit', function(e){
      var f = e.target;
      var action = f && f.getAttribute && f.getAttribute('action');
      if (action && action.indexOf('/cart/add') !== -1) { kbfFsRefetch(); setTimeout(kbfFsRefetch, 1200); }
    }, true);
    document.addEventListener('click', function(e){
      var el = e.target.closest && e.target.closest('[rv-data-cart-update], [rv-data-cart-remove], .qtyBtn, [class*="cart-remove"], [class*="cart-update"]');
      if (el) { kbfFsRefetch(); setTimeout(kbfFsRefetch, 900); }
    }, true);

    kbfFsCheckAndRender(true);
    setInterval(function(){ kbfFsCheckAndRender(false); }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kbfFsInitHooks);
  } else {
    kbfFsInitHooks();
  }
})();
